import React, { useEffect, useId, useRef, useState } from "react";
import { IconDotsVertical } from "@tabler/icons-react";
import "./action-menu.scss";

// Small "more actions" menu. items: [{ label, icon: Icon, onSelect, tone: "danger" }]
const ActionMenu = ({ items, label = "More actions" }) => {
  const id = useId();
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="action-menu" ref={ref}>
      <button
        type="button"
        className="btn btn--ghost btn--icon action-menu__toggle"
        aria-label={label}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen((o) => !o)}
      >
        <IconDotsVertical size={18} stroke={1.75} />
      </button>
      {open && (
        <ul className="action-menu__list" id={id} role="menu">
          {items.map(({ label: itemLabel, icon: Icon, onSelect, tone }) => (
            <li key={itemLabel} role="none">
              <button
                type="button"
                role="menuitem"
                className={`action-menu__item ${tone ? `action-menu__item--${tone}` : ""}`}
                onClick={() => {
                  setOpen(false);
                  onSelect();
                }}
              >
                {Icon && <Icon size={16} stroke={1.75} />}
                {itemLabel}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ActionMenu;
